(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vat-switcher"] && !Shopify.designMode) return;
  try {
    class VatSwitcher extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
      this.classList.add('show');
    }
    init() {
      this.vat_buttons = this.querySelectorAll('.pdp-switcher_button');
      this.updateButtons();
      this.vat_buttons.forEach((button) => {
        button.addEventListener('click', e => {
          this.classList.add('enable-transition');
          let value = event.currentTarget.getAttribute("data-value");
          if (value == "inc-vat") {                
            localStorage.setItem('include_vat', 'false');
          } else {
            localStorage.setItem('include_vat', 'true');
          }
          window.toggleVat();
          this.updateButtons();
        })
      });
    }
    updateButtons() {
      const include_vat = localStorage.getItem('include_vat');
      if (include_vat === 'true') {
        this.vat_buttons.forEach((vat_button) => {
          vat_button.setAttribute("data-value", "inc-vat");
          vat_button.classList.add('pdp-withVat');
          vat_button.firstChild.classList.add('pdp-withVat');
        })
      } else {
        this.vat_buttons.forEach((vat_button) => {
          vat_button.setAttribute("data-value", "ex-vat");
          vat_button.classList.remove('pdp-withVat');
          vat_button.firstChild.classList.remove('pdp-withVat');
        })
      }
    }
  }
  if(!customElements.get('vat-switcher')) {
    customElements.define('vat-switcher', VatSwitcher);
  }
  } catch(e) { console.error(e); }
})();

})();
